import { Button, Modal } from "antd";
import React from "react";
import Cancel from "../../assets/ImageAddControl/cancel.svg";

type Props = {
  onOk: () => void;
  onCancel: () => void;
  visible: boolean;
  checkBlackList: boolean;
  children?: React.ReactNode;
};
const LegalEntiryBlackListModal: React.FC<Props> = ({
  onOk,
  onCancel,
  visible,
  checkBlackList,
  children,
}) => {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
      centered
      closable={false}
      maskClosable={false}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "20px",
          minHeight: "300px",
        }}
      >
        <div
          style={{
            fontWeight: "bold",
            fontSize: "2rem",
            textAlign: "center",
            width: "80%",
          }}
        >
          {checkBlackList ? (
            children
          ) : (
            <>
              <img
                src={Cancel}
                alt="Cancel"
                style={{ width: "200px", height: "200px" }}
              />
              <div>
                ปฎิเสธลงทะเบียนผู้ค้ากับสภากาชาดไทย เนื่องจากข้อมูลติด Blacklist
              </div>
            </>
          )}

          <div
            style={{
              display: "grid",
              gridTemplateColumns: `repeat(${checkBlackList ? "2" : "1"},1fr)`,
              gap: "1rem",
              marginTop: "4rem",
            }}
          >
            <Button
              style={{
                backgroundColor: "#C95559",
                color: "#F0F0F0",
                borderRadius: "8px",
                height: "60px",
                fontSize: "2rem",
                fontWeight: "bold",
              }}
              onClick={onCancel}
            >
              {checkBlackList ? "ไม่ยีนยัน" : "ยืนยัน"}
            </Button>
            {checkBlackList && (
              <Button
                style={{
                  backgroundColor: "#6598F6",
                  color: "#F0F0F0",
                  borderRadius: "8px",
                  height: "60px",
                  fontSize: "2rem",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  onOk();
                }}
              >
                ยืนยัน
              </Button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default LegalEntiryBlackListModal;
